import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT";

const AuthService = {
  login: async (payload) => {
    const response = await axios.post(`${ENDPOINTS.BASE}/auth/login`, payload);
    return response.data;
  },

  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
  },

  getCurrentUser: () => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  },

  getToken: () => localStorage.getItem("token"),

  isLoggedIn: () => !!localStorage.getItem("token"),
};

export default AuthService;